import { render } from "./add-meditation.vue?vue&type=template&id=bb61ff34"
import script from "./add-meditation.vue?vue&type=script&lang=js"
export * from "./add-meditation.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/stages_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__